/** Formats handled by the existing document parser, shared by the picker and server. */
export const CHAT_OFFICE_EXTENSIONS = ["pdf", "docx", "xlsx", "pptx", "odt", "ods", "odp", "rtf", "epub"] as const;
const TEXT_EXTENSIONS = new Set([
  "txt", "md", "markdown", "csv", "json", "xml", "html", "htm", "yaml", "yml",
  "log", "sql", "js", "ts", "jsx", "tsx", "py", "java", "go", "php", "c", "cpp",
  "h", "cs", "rb", "rs", "sh", "css", "vue",
]);
const DOCUMENT_MEDIA_TYPES = new Set([
  "application/pdf", "application/rtf", "application/epub+zip",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.oasis.opendocument.text", "application/vnd.oasis.opendocument.spreadsheet",
  "application/vnd.oasis.opendocument.presentation", "application/json", "application/xml",
  "application/javascript", "application/x-yaml",
]);

export function isReadableChatDocument(mediaType: string, filename?: string): boolean {
  if (filename) {
    const extension = filename.split(".").at(-1)?.toLowerCase() ?? "";
    // A misleading text MIME must not allow binary archives or old Office formats.
    return (CHAT_OFFICE_EXTENSIONS as readonly string[]).includes(extension) || TEXT_EXTENSIONS.has(extension);
  }
  return mediaType.startsWith("text/") || DOCUMENT_MEDIA_TYPES.has(mediaType);
}
